import * as angular from 'angular';
import { wtDroppableDrop } from '../common';
import { DirectiveDefinition } from './directiveDefinition';

export interface IWtDroppableScope extends angular.IScope {
    bin: string;
    drop?: (data: any, binId?: string) => void;
    wtDropDisabled: boolean;
}

class WtDroppableController implements angular.IController {
    static $inject = ['$scope', '$element'];

    constructor(
        private $scope: IWtDroppableScope,
        private $element: angular.IAugmentedJQuery) {
    }

    $onInit() {
        const scope = this.$scope;

        const stopPropagation = e => {
            // Stops some browsers from redirecting.
            if (e.preventDefault) {
                e.preventDefault();
            }
            if (e.stopPropagation) {
                e.stopPropagation();
            }
        };

        // again we need the native object
        const el = this.$element[0];

        el.addEventListener(
            'dragover',
            function (e: DragEvent) {
                if (!scope.wtDropDisabled) {
                    e.dataTransfer.dropEffect = 'move';
                    stopPropagation(e);
                    // allows us to drop

                    this.classList.add('over');
                }
                return false;
            },
            false
        );

        el.addEventListener(
            'dragenter',
            function (e: DragEvent) {
                if (!scope.wtDropDisabled) {
                    stopPropagation(e);
                    this.classList.add('over');
                }
                return false;
            },
            false
        );

        el.addEventListener(
            'dragleave',
            function (e: DragEvent) {
                if (!scope.wtDropDisabled) {
                    stopPropagation(e);
                    this.classList.remove('over');
                }
                return false;
            },
            false
        );
        const self = this;
        el.addEventListener(
            'drop',
            function (e: DragEvent) {
                if (!scope.wtDropDisabled) {
                    stopPropagation(e);

                    this.classList.remove('over');

                    const binId = this.id;
                    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
                        if (scope.drop) {
                            scope.drop({ data: e.dataTransfer.files, binId: binId });
                        }
                    } else {
                        const elementId = e.dataTransfer.getData('Text');
                        const item = document.getElementById(elementId);
                        self.apply(scope, item, binId, e);
                    }
                }
                return false;
            },
            false
        );
    }

    private apply(scope: IWtDroppableScope, item: HTMLElement, binId: string, e: DragEvent) {
        scope.$apply((dropScope: IWtDroppableScope) => {
            const data = { itemId: item ? item.id : undefined, binId: binId };
            dropScope.$emit(wtDroppableDrop, data);
            if (dropScope.drop) {
                const result: any = { data: data };
                try {
                    const dragObject = e.dataTransfer.getData('Text');
                    if (dragObject) {
                        result.dragObject = JSON.parse(dragObject);
                    }
                } catch (ex) {
                    if (!data.itemId) {
                        data.itemId = e.dataTransfer.getData('Text');
                    }
                }
                dropScope.drop(result);
            }
        });
    }
}

export const WtDroppableDirective: DirectiveDefinition = {
    directiveId: 'wtDroppable',
    restrict: 'A',
    controller: WtDroppableController,
    scope: {
        drop: '&',
        bin: '=',
        wtDropDisabled: '='
    }
};